

import React, { useState } from 'react';

interface Props {
  onAddToBothSheets: (guid: string, terms: string[]) => void;
}

const FrameworkRefForm: React.FC<Props> = ({ onAddToBothSheets }) => {
  const [noticeId, setNoticeId] = useState('');
  const [guid, setGuid] = useState('');
  const [terms, setTerms] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let finalGuid = guid;

    if (!finalGuid && noticeId) {
      try {
        const response = await fetch(`/api/guid-from-notice-id/${encodeURIComponent(noticeId)}`);
        const result = await response.json();
        if (result.status === 'success') {
          finalGuid = result.guid;
        } else {
          alert('Failed to find GUID from Notice ID');
          return;
        }
      } catch (error) {
        console.error('Error fetching GUID:', error);
        alert('Error fetching GUID');
        return;
      }
    }

    const termList = terms.split(',').map(t => t.trim()).filter(Boolean);

    if (!finalGuid || termList.length === 0) {
      alert('Please provide a GUID or Notice ID, and at least one term');
      return;
    }

    onAddToBothSheets(finalGuid, termList);
    setNoticeId('');
    setGuid('');
    setTerms('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input
        type="text"
        placeholder="Notice ID (optional)"
        value={noticeId}
        onChange={(e) => setNoticeId(e.target.value)}
      />
      <input
        type="text"
        placeholder="GUID (optional)"
        value={guid}
        onChange={(e) => setGuid(e.target.value)}
      />
      <input
        type="text"
        placeholder="Framework terms (comma-separated)"
        value={terms}
        onChange={(e) => setTerms(e.target.value)}
        required
      />
      <button type="submit">Add Framework Identifier</button>
    </form>
  );
};

export default FrameworkRefForm;